export { default as topMagazineItem } from '@handlebars/top/top-magazine-item.hbs';
export { default as topRecommendItem } from '@handlebars/top/top-recommend-item.hbs';
export { default as topWriterItem } from '@handlebars/top/top-writer-item.hbs';
